import Vue from 'vue'
import App from './App.vue'
import router from './router'
import MetaInfo from 'vue-meta-info';
import point from './point/point'
import VueLazyload from 'vue-lazyload'
 
Vue.use(VueLazyload)
// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '',
  loading: '',
  attempt: 1
})


//路由器

Vue.config.productionTip = false
Vue.use(MetaInfo)
Vue.prototype.$point = point


new Vue({
  el: '#app',
  router,
  render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js